import { Box, Card, CardContent, Chip, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import HistoryIcon from '@mui/icons-material/History';
import parse from 'html-react-parser';
import { NoteCardProps } from './types';

const NoteCard = ({ note, onEdit, onDelete, onHistory }: NoteCardProps) => {
  const authorDisplay = note.author_name || note.user || 'Unknown';
  const createdDate = new Date(note.created_at).toLocaleString();
  const isEdited = !!note.updated_at;

  return (
    <Card variant="outlined" sx={{ mb: 1.5 }}>
      <CardContent sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Stack direction="column" sx={{ gap: '8px', '& p': { margin: 0 }, '& ul': { margin: 0 } }}>
            {parse(note.note)}
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="caption" color="text.secondary" fontWeight={600}>
                {authorDisplay}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {createdDate}
              </Typography>
              {isEdited && (
                <Typography variant="caption" color="text.secondary" fontStyle="italic">
                  (Edited)
                </Typography>
              )}
              <Chip
                label={note.visible_to_partner ? 'Partner Visible' : 'Internal Only'}
                size="small"
                color={note.visible_to_partner ? 'success' : 'warning'}
                variant="outlined"
                sx={{ height: 20, fontSize: '0.7rem' }}
              />
            </Stack>
          </Stack>
          <Stack direction="row" spacing={0.5}>
            <Tooltip title="Edit">
              <IconButton size="small" onClick={() => onEdit(note)}>
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton size="small" onClick={() => onDelete(note.id)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="History">
              <IconButton size="small" onClick={() => onHistory(note.id)}>
                <HistoryIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default NoteCard;
